import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ArkikWebComponentsModule } from '@core/modules';
import { ArkikDialogModule } from '@shared/components/arkik-dialog/arkik-dialog.module';
import { ModalConfirmationComponent } from './modal-confirmation.component';

/**
 * Programmatic component — opened via ArkikDialogService.open(ModalConfirmationComponent, ...).
 * Not used in any template. Must be imported at app root level so Ivy compiles it.
 *
 * Used in:
 * - orders/order-taking (ValueAddedTbl2, ValueAdded, ServiceAdded)
 * - admin-manager/parameters (ParameterValuesListComponent)
 * - admin-manager/menus (MenusManagerComponent)
 * - admin-manager/companies-manager (CompaniesManagerProductPrice, CompanyEditModal)
 */
@NgModule({
  declarations: [ModalConfirmationComponent],
  imports: [CommonModule, ArkikWebComponentsModule, ArkikDialogModule],
  exports: [ModalConfirmationComponent],
})
export class ModalConfirmationComponentModule {}
